import React, { useContext } from 'react';
import './ImageList.scss';
import ImageCard from 'component/ImageCard';
import { FileContext } from 'context/FileContext';

function ImageList(props: { files: File[], className?: string }): JSX.Element {
  const { files, className } = props;
  const fileContext = useContext(FileContext);

  const images = files
    .map((file, index) => (
      <ImageCard
        key={file.name}
        deleteFile={fileContext.deleteFile}
        file={file}
        src={fileContext.urls[index]}
      />
    ));

  return (
    <article className={`image-list ${className}`}>
      {images}
    </article>
  );
}

ImageList.defaultProps = {
  className: false,
};

export default ImageList;
